export default function showDate(date){
    return date? date.split("T")[0].split("-").reverse().join("-") : "Not Updated"
}